import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AuthError = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      gap={2}
    >
      <Error color="error" sx={{ fontSize: 60 }} />
      <Typography variant="h5" gutterBottom>
        Authentication Failed
      </Typography>
      <Typography color="text.secondary" textAlign="center">
        There was an error during the login process. Please try again.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{ mt: 2 }}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default AuthError;
